import React, { useState, useCallback, useEffect } from 'react';

interface iProps {
  className?: string;
  onChange: (value: string) => void;
  isModified: (a: boolean) => void;
  value: string;
  editable: boolean;
}

function ContentEditable(props: iProps): JSX.Element {
  const { editable, onChange, value, className, isModified } = props;

  const [rawValue, setRawValue] = useState<string>('');

  useEffect(() => {
    if (rawValue === '') setRawValue(value);
  }, [value]);

  const onBlurHandler = useCallback(
    (event) => {
      const { textContent } = event.currentTarget;
      setRawValue(textContent);
      onChange(textContent);
    },
    [onChange]
  );

  return (
    <div
      className={className}
      contentEditable={editable}
      onBlur={onBlurHandler}
      onInput={() => {
        isModified(true);
      }}
      dangerouslySetInnerHTML={{ __html: rawValue }}
    />
  );
}

ContentEditable.defaultProps = {
  className: '',
};

export default ContentEditable;
